import React from 'react';
import { useTranslation } from 'react-i18next';

import { CustomTypography } from '@/shared/ui/Typography';

export const WarningTextAboutDialogs = () => {
  const { t } = useTranslation();

  return (
    <>
      <CustomTypography component="span" variant="body1">
        {t('channels:warningTextLazyLoadDialogs.part1')}
      </CustomTypography>
      <CustomTypography
        component="span"
        variant="body1"
        sx={{ fontWeight: 600 }}
      >
        {t('channels:warningTextLazyLoadDialogs.part2')}
      </CustomTypography>
      <CustomTypography variant="body1">
        {t('channels:warningTextLazyLoadDialogs.part3')}
      </CustomTypography>
    </>
  );
};
